import { FC } from 'react'
import { DealProvider } from './DealContext'
import { DealDetailWithProvider } from './DealDetailWithProvider'
import { SpecsProvider } from './SpecsContext'

export const DealDetail: FC = () => {
  return (
    <DealProvider>
      <SpecsProvider>
        <DealDetailWithProvider />
      </SpecsProvider>
    </DealProvider>
  )
}
